module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/008-estonia-e970fda205be5d8ff3bd2586a03700f1.svg";